import { initializeChoicesFromApiSelects } from './choicesFromApiSelect';
import { store } from './reactTreeMounting';
import { NAVBAR_HEIGHT } from 'LEGACY/constants';

function resetFields(container) {
  const fields = container.find('input, select, textarea');
  const checkableFields = fields.filter('input[type="checkbox"], input[type="radio"]');
  const valueFields = fields.not('input[type="checkbox"], input[type="radio"], input[type="file"]');
  const fileUploadField = container.find('.react_fileUploadField');

  checkableFields.prop('checked', false).change();
  valueFields.val('').change();

  if (fileUploadField.length) {
    const uppyRemoveFiles = new CustomEvent('uppyRemoveFiles', { detail: fileUploadField.data('input-name') });
    window.dispatchEvent(uppyRemoveFiles);
  }
  // Specific to ButtonGroups.
  container.find('button').removeClass('btn-primary').addClass('btn-default');
}

function conditionalDisabling(container, disable) {
  if (disable) {
    resetFields(container);
    container.find('button, input, select, textarea, section').prop('disabled', true);
  } else {
    container.find('button, input, select, textarea, section').prop('disabled', false);
  }
}

function conditionalShowing(container, show) {
  if (show) {
    container.find('section, button, input, select, textarea').prop('disabled', false);
    container.find('select').select2({
      theme: 'bootstrap',
      width: '100%',
    });
    container.removeClass('hidden');
    container.parent('.conditionalShowing-block').removeClass('hidden');
  } else {
    resetFields(container);
    container.addClass('hidden');
    container.find('section, button, input, select, textarea').prop('disabled', true);
    container.find('select.select2-hidden-accessible').select2('destroy');
    const block = container.parent('.conditionalShowing-block');
    if (block.length && !block.find('.conditionalShowing:not(.hidden)').length) {
      block.addClass('hidden');
    }
  }
}

export function conditionalField(element) {
  /**
   * Display or hide inputs that have conditional showing, enable or disable inputs that have conditional disabling
   * according to related radio/checkbox state.
   */
  const currentName = element.prop('name') || element.prop('id');
  const linked = $(`[data-conditional-field="${currentName}"]`);
  if (!linked.length) {
    return;
  }
  linked.each(function triggerConditionalField() {
    let showOrDisable;
    const linkedValues = $(this).data('conditional-value');

    if (element.prop('type') === 'checkbox') {
      for (const linkedValue of linkedValues) {
        const showOrDisableName = Boolean($(`[name="${currentName}"][value="${linkedValue}"]:checked`).length);
        const showOrDisableID = Boolean($(`[id="${currentName}"][value="${linkedValue}"]:checked`).length);

        showOrDisable = showOrDisableName || showOrDisableID;
        if (showOrDisable) {
          break;
        }
      }
    } else if (element.prop('type') === 'radio') {
      const checkedByName = $(`input[type="radio"][name="${currentName}"]:checked`);
      const checkedRadio = checkedByName.length ? checkedByName : $(`input[type="radio"][id="${currentName}"]:checked`);
      const elementValue = checkedRadio.val();

      showOrDisable = (linkedValues.includes('*') && elementValue) || linkedValues.includes(elementValue);
    } else {
      const elementValue = element.val();
      if (Array.isArray(elementValue)) {
        showOrDisable = linkedValues.some(value => elementValue.includes(value));
      } else {
        showOrDisable = (linkedValues.includes('*') && elementValue) || linkedValues.includes(elementValue);
      }
    }
    if ($(this).hasClass('conditionalDisabling')) {
      conditionalDisabling($(this), showOrDisable);
    }
    if ($(this).hasClass('conditionalShowing')) {
      conditionalShowing($(this), showOrDisable);
    }
  });
}
$(document).on('change', 'input, select, section', function handleConditionalField() {
  conditionalField($(this));
});

export function handleProjectChange() {
  const selectedOption = $('#patient-project_id option:selected');
  const hasAccessToCcd = selectedOption.data('has-access-to-ccd') === 'yes';
  const ccdRadioInputs = $('input[name*="ccd_case"]');
  const ccdFieldContainer = ccdRadioInputs.closest('div[class*="col-sm-"]');

  ccdFieldContainer.toggle(hasAccessToCcd);

  // When hidden, remove required attribute to prevent form validation from blocking submission
  // When visible, restore required attribute for proper validation
  if (hasAccessToCcd) {
    ccdRadioInputs.prop('required', true);
  } else {
    ccdRadioInputs.prop('required', false);
    // Uncheck all radio buttons to clear any previous selection
    ccdRadioInputs.prop('checked', false);
  }
}
$(document).on('change', '#patient-project_id', function() {
  handleProjectChange();
});

function updateRequiredIf(input) {
  const hasValue = !!input.value;
  document.querySelectorAll(`[data-required-if="${input.id}"]`).forEach(el => {
    el.required = hasValue;
  });
}

document.addEventListener('input', function handleRequiredIf(e) {
  if (e.target.matches('input[id]')) {
    updateRequiredIf(e.target);
  }
});

$(document).ready(function() {
  handleProjectChange();
  document.querySelectorAll('input[id]').forEach(updateRequiredIf);
});

function formatRecipient(state, container) {
  /**
   * Format recipient selector elements.
   */
  if (!state.id) {
    return state.text;
  }

  if (state.element.classList.contains('medco')) {
    $(container).addClass('medco');
  }

  const icon = state.element.classList.contains('group') ? '<i class="fas fa-users"></i>' : '<i class="fas fa-user"></i>';
  const unavailable = state.element.classList.contains('unavailable') ? ' <span class="user-status unavailable"></span>' : ' <span class="user-status"></span>';
  return $(`${icon}${unavailable}<span class="recipient-display">${state.text}</span>`);
}

function formatColorCode(state) {
  /**
   * Format color code selector elements.
   */
  if (!state.id) {
    return state.text;
  }

  return $('<i class="fas fa-square">').addClass($(state.element).attr('class'));
}

const DISPATCH_STATIONS_SELECTOR = '.dispatch-stations-select';
const TENANT_SELECT_SELECTOR = '#patient-tenant_id';

function matchDispatchStationToSelectedTenant(params, data) {
  /**
   * Restrict the SMUR dispatch stations dropdown to the stations belonging to the tenant
   * currently selected in the consultation creation form (if any), on top of the usual text search.
   */
  if (!data.id) {
    return data;
  }

  const tenantIds = $(data.element).data('tenant-ids');
  const selectedTenantId = $(TENANT_SELECT_SELECTOR).val();
  if (Array.isArray(tenantIds) && tenantIds.length && selectedTenantId && !tenantIds.includes(selectedTenantId)) {
    return null;
  }

  if (!params.term || params.term.trim() === '') {
    return data;
  }

  const text = (data.text || '').toString().toUpperCase();
  return text.indexOf(params.term.toUpperCase()) > -1 ? data : null;
}

// Stations proposed for dispatch are tenant-specific: clear the selection when the tenant changes.
$(document).on('change', TENANT_SELECT_SELECTOR, function onTenantChange() {
  $(DISPATCH_STATIONS_SELECTOR).val(null).trigger('change');
});

export function initializeSelect2() {
  const locale = store?.getState().user.locale || window.userLocale;

  // Select2 overrides standard selects.
  $('select:not([disabled]):not(.exclude_standard_select2)').select2({
    theme: 'bootstrap',
    width: '100%',
  });
  // Selects whose choices are searched for via an API call rather than preloaded.
  initializeChoicesFromApiSelects();
  // Select2 configuration specific to recipient selection.
  $(`.select2_recipients:not(${DISPATCH_STATIONS_SELECTOR})`).select2({
    templateResult: formatRecipient,
    templateSelection: formatRecipient,
    language: locale,
    theme: 'bootstrap',
    width: '100%',
  });
  // SMUR dispatch stations: same recipient rendering, plus tenant-based filtering.
  $(DISPATCH_STATIONS_SELECTOR).select2({
    templateResult: formatRecipient,
    templateSelection: formatRecipient,
    matcher: matchDispatchStationToSelectedTenant,
    language: locale,
    theme: 'bootstrap',
    width: '100%',
  });
  $('#consultation-color_code').select2({
    templateResult: formatColorCode,
    templateSelection: formatColorCode,
    theme: 'bootstrap',
    width: '60px',
    minimumResultsForSearch: Infinity,
  });

  // we need to apply a workaround on the remove X icon (select2-selection__choice__remove) for Apple devices
  if (/Mac|iPhone/i.test(navigator.userAgent)) {
    $('.select2').addClass('apple-device');
  }
}

/**
 * Scroll to the first field error.
 * This does not apply to firefox because the tooltips scroll with the page, instead of staying
 * on the input. (https://bugzilla.mozilla.org/show_bug.cgi?id=643758)
 * Only works within the consultation container content__container. Includes some Safari workarounds.
 */
export const scrollToFirstFormInvalidElement = () => {
  if (navigator.userAgent.includes('Mozilla')) {
    return;
  }

  const errorElements = Array.from(document.querySelectorAll(':invalid')).filter(node => node.nodeName !== 'FORM');
  // Safari does not include the required checkboxes in the :invalid elements.
  if (navigator.userAgent.includes('Safari')) {
    const checkboxes = Array.from(document.querySelectorAll('input[type=checkbox]'));
    errorElements.push(...checkboxes.filter(checkbox => checkbox.checkValidity()));
  }
  const scrollableDiv = document.querySelectorAll('.main-content__container')[0];
  if (errorElements.length && scrollableDiv) {
    const scrollableDivYPosition = scrollableDiv.scrollTop - scrollableDiv.getBoundingClientRect().top;
    const relativeOffsetY = errorElements[0].getBoundingClientRect().top;
    scrollableDiv.scrollTop = Math.max(scrollableDivYPosition + relativeOffsetY - NAVBAR_HEIGHT, 0);
  }
};

export function validateRequiredCheckboxes(form) {
  form.querySelectorAll('.checkbox_required').forEach(div => {
    if (div.querySelectorAll('input[type=checkbox]:checked').length === 0) {
      div.querySelector('input[type=checkbox]').setCustomValidity('Please select one of these options.');
    }
  });
}

$(document).on('shown.bs.collapse', '.panel-collapse', function displayPanel(event) {
  // The js event bubbles to the parent panel (event) when opening an exam.
  if (!$(this).is(event.target)) {
    return;
  }
  if (!$(this).prev('.event-toggle, .exam-toggle').length) {
    return;
  }

  const panel = $(this).parent('.panel')[0];
  panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
});
